import React from 'react';
import { AppBar, Toolbar, Box, Container, Stack, Typography, Button, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import savvyLogoTransparent from '../assets/img/savvy-transparent-logo.png';

const brand = {
  primary: '#800b33',
  dark: '#5c0620',
  slate: '#1d1320',
  tint: '#ffe9ef',
  paper: '#fff',
};

const navLinks = [
  { label: 'Product', href: '#product' },
  { label: 'Solutions', href: '#solutions' },
  { label: 'Company', href: '/terms' },
];

const LandingNavbar = () => (
  <AppBar
    position="sticky"
    elevation={3}
    sx={{ bgcolor: 'rgba(255,255,255,0.98)', color: brand.slate, borderBottom: '1px solid rgba(0,0,0,0.05)' }}
  >
    <Container maxWidth="xl">
      <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
        <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none' }}>
          <Box
            component="img"
            src={savvyLogoTransparent}
            alt="Savvy Community logo"
            sx={{
              width: 46,
              height: 46,
              objectFit: 'contain',
              borderRadius: '12px',
              background: 'transparent',
            }}
          />
          <Typography variant="h6" sx={{ fontWeight: 700, color: brand.primary }}>
            Savvy Community
          </Typography>
        </Box>
        <Stack direction="row" spacing={3} alignItems="center" sx={{ display: { xs: 'none', md: 'flex' } }}>
          {navLinks.map((link) => (
            <Box
              key={link.label}
              component="a"
              href={link.href}
              sx={{
                color: brand.slate,
                fontWeight: 600,
                textDecoration: 'none',
                '&:hover': { color: brand.primary },
              }}
            >
              {link.label}
            </Box>
          ))}
          <Button
            component={RouterLink}
            to="/login"
            variant="contained"
            sx={{
              bgcolor: brand.primary,
              textTransform: 'none',
              px: 4,
              py: 1.5,
              borderRadius: 3,
              fontWeight: 700,
              '&:hover': { bgcolor: brand.dark },
              color: '#fff',
            }}
          >
            Start now
          </Button>
        </Stack>
        <IconButton sx={{ display: { md: 'none' }, color: brand.primary }}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </Container>
  </AppBar>
);

export { LandingNavbar };
